// BaseTable.jsx
import React from "react";
import { lowerCase, startCase, sortBy } from 'lodash';

export default class BaseTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortable: this.props.sortable || true,
      sortKey: null,
      sortDesc: false,
    };
  }

  static defaultProps = {
    data: [],
    actions: [],
    columnLabels: {},
  };

  getSortedData = () => {
    let { sortKey } = this.state;
    let { data } = this.props;
    if (!(sortKey || data.length)) return data;

    if (Object.keys(data[0]).includes('_' + sortKey)) {
      sortKey = '_' + sortKey;
    }
    let sortedData = sortBy(data, [sortKey]);
    return this.state.sortDesc ? sortedData.reverse() : sortedData;
  };

  toggleSortForColumn = (column_name) => {
    if (this.state.sortable) {
      if (this.state.sortKey === column_name) {
        if (!this.state.sortDesc) {
          this.setState({ sortDesc: true });
        } else {
          this.setState({ sortKey: null, sortDesc: false });
        }
      } else {
        this.setState({ sortKey: column_name });
      }
    }
  };

  buildTableHeader = () => {
    const { data, actions, columns, columnLabels } = this.props;
    if (!data.length) return;
    const headers = columns || Object.keys(data[0]).filter(d => d.charAt(0) !== '_');

    return (
      <thead>
        {!!actions && !!actions.length && (
          <th style={{ opacity: 0 }}>--</th>
        )}
        {headers.map((key) => {
          const label = (columnLabels && columnLabels[key]) ?? startCase(key); // 👈 usa label custom si viene
          return (
            <th
              key={key} // 👈 key para React
              className={`table header cursor-is-pointer ${this.state.sortKey === key ? 'sorted-table-header' : ''}`}
              onClick={() => this.toggleSortForColumn(key)}
            >
              {label} {(this.state.sortable && this.state.sortKey === key) && (this.state.sortDesc ? '▲' : '▼')}
            </th>
          );
        })}
      </thead>
    );
  };

  buildTableRows = () => {
    const { data, actions, columns, rowStyle } = this.props;
    if (!data.length) return;
    const headers = columns || Object.keys(data[0]).filter(d => d.charAt(0) !== '_');

    return (
      <tbody>
        {this.getSortedData().map((row, i) => (
          <tr
            key={row.id ?? i} // 👈 key para React
            className={row._is_selected ? 'is_selected' : ''}
            onClick={this.props.onRowClick ? () => this.props.onRowClick(row) : undefined}
          >
            {actions && !!actions.length && (
              <td>
                <span className="is-flex">
                  {actions.map((a, idx) => (
                    <span
                      key={idx} // 👈 key para React
                      className="table-action mx-3"
                      onClick={() => a.action(row)}
                    >
                      {typeof a.elem === 'function' ? a.elem(row) : a.elem}
                    </span>
                  ))}
                </span>
              </td>
            )}
            {headers.map((h) => (
              <td key={h} className={rowStyle}>
                {row['_html_' + h] || row[h]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  };

  render() {
    return (
      <table className={'table ' + this.props.className}>
        {this.buildTableHeader()}
        {this.buildTableRows()}
      </table>
    );
  }
}